import { MiDetailFields } from "@miplatform/components";
import { ENTITY_NAMES, SECTION_HEADER_VARIANTS } from "@miplatform/constants";
import { useEdit } from "@miplatform/hooks";
import { IWorkOrderInfo } from "@miplatform/types";
import { convertTimeToShortHand } from "@miplatform/utils";
import { mdiInformationOutline } from "@mdi/js";

export const WorkOrderDetailFields = ({
  workOrder,
}: WorkOrderDetailFieldsProps) => {
  const edit = useEdit(workOrder);

  const fields = [
    {
      label: ENTITY_NAMES.WORK_ORDER_TEMPLATE,
      name: "workOrderTemplateName",
      width: "50%",
      readOnly: true,
    },
    {
      label: "Due Date",
      name: "hardDueDate",
      value: workOrder?.hardDueDate
        ? convertTimeToShortHand(workOrder.hardDueDate)
        : "-- @ --",
      width: "50%",
      readOnly: true,
    },
  ];

  return (
    <MiDetailFields
      edit={edit}
      detailFields={fields}
      headerProps={{
        title: ENTITY_NAMES.WORK_ORDER,
        icon: mdiInformationOutline,
        variant: SECTION_HEADER_VARIANTS.UNDERLINED,
      }}
    />
  );
};

interface WorkOrderDetailFieldsProps {
  workOrder: IWorkOrderInfo;
}
